export const roadhealth = [
    {
        id: 0,
        thumbnail:
            "https://i.ibb.co/VL5G53c/My-english-bro-Personajek-09.png",
        title: "Medicina and Nursing",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"[📝 Glossary]  Pain Description",url: "https://drive.google.com/file/d/1Si0g_dX0QorX0Dgr1eEnWzNxrMVKEFdN/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] Anxiety",url: "https://drive.google.com/file/d/1OxqayWzvgKNHFE0q3WqA8cNCmaEi30h9/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] GASTROENTEROLOGY_MED_HX",url: "https://drive.google.com/file/d/1ippJsOFPKUaeUPyL4RS7MCamDZEi4fLP/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] ENDOSCOPY",url: "https://drive.google.com/file/d/19uyTXIZZFhWzuIAa7CFEkfGHabWAEEGR/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] IMMUNIZATIONS",url: "https://drive.google.com/file/d/1-DrGo53UoTNeHkRrelpvVP4u96n8M9-l/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] Transvaginal_ultrasound",url: "https://drive.google.com/file/d/1HeqNVrLqNNPC9pNbRiG6IxYDVbqUssj4/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] Quemotherapy",url: "https://drive.google.com/file/d/1lnB9URVJ4TW4ldSwtMfWtczOwNHC3IE9/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] STREP_THROAT",url: "https://drive.google.com/file/d/1Jae_coXXroC0pxt4E88wvWwM9x1Xj8Vi/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] MEDICAL_HISTORY",url: "https://drive.google.com/file/d/14DN4uyNtMjuFp8u472xh4C8A3HdLkPef/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] HYPERTENSION",url: "https://drive.google.com/file/d/1wHgQ3zC-lqE4pYByUcOYoKqwzIWVVEoH/view?usp=sharing"},        
            {  titulo:" HYPERTENSION",url: "https://www.youtube.com/watch?v=drp9ZXUF1D8&t=39s&ab_channel=MyEnglishBro"},        

            {  titulo:"[📝 Glossary]  Pain Description II",url: "https://drive.google.com/file/d/1E0wT7dprhTg1EmAsutWKJCJvvTqDQ539/view?usp=sharing"},        

            
        ],
    },
    {
        id: 0,
        thumbnail:
            "https://i.ibb.co/VL5G53c/My-english-bro-Personajek-09.png",
        title: "Medicina and Nursing",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"[📝 Glossary]  Pain Description",url: "https://drive.google.com/file/d/1Si0g_dX0QorX0Dgr1eEnWzNxrMVKEFdN/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] Anxiety",url: "https://drive.google.com/file/d/1OxqayWzvgKNHFE0q3WqA8cNCmaEi30h9/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] GASTROENTEROLOGY_MED_HX",url: "https://drive.google.com/file/d/1ippJsOFPKUaeUPyL4RS7MCamDZEi4fLP/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] ENDOSCOPY",url: "https://drive.google.com/file/d/19uyTXIZZFhWzuIAa7CFEkfGHabWAEEGR/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] IMMUNIZATIONS",url: "https://drive.google.com/file/d/1-DrGo53UoTNeHkRrelpvVP4u96n8M9-l/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] Transvaginal_ultrasound",url: "https://drive.google.com/file/d/1HeqNVrLqNNPC9pNbRiG6IxYDVbqUssj4/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] Quemotherapy",url: "https://drive.google.com/file/d/1lnB9URVJ4TW4ldSwtMfWtczOwNHC3IE9/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] STREP_THROAT",url: "https://drive.google.com/file/d/1Jae_coXXroC0pxt4E88wvWwM9x1Xj8Vi/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] MEDICAL_HISTORY",url: "https://drive.google.com/file/d/14DN4uyNtMjuFp8u472xh4C8A3HdLkPef/view?usp=sharing"},        
            {  titulo:"[💭 Roll Play ] HYPERTENSION",url: "https://drive.google.com/file/d/1wHgQ3zC-lqE4pYByUcOYoKqwzIWVVEoH/view?usp=sharing"},        
            {  titulo:"[📝 Glossary]  Pain Description II",url: "https://drive.google.com/file/d/1E0wT7dprhTg1EmAsutWKJCJvvTqDQ539/view?usp=sharing"},        

            
        ],
    },
    
    
];
